export const defaultActions = {
  learnMore: 'global.learnMore',
  startProcess: 'global.startProcess',
};
